import { BaseError } from "../BaseError";

export const PLAY_STYLE = { SP: 1, DP: 2 } as const;

export type PlayStyle = (typeof PLAY_STYLE)[keyof typeof PLAY_STYLE];

export const PLAY_STYLE_STRING = { 1: "SP", 2: "DP" } as const;

export const isPlayStyle = (n: unknown): n is PlayStyle => {
  return typeof n === "number" && Object.values<typeof n>(PLAY_STYLE).includes(n);
};

export const parsePlayStyle = (n: number): PlayStyle => {
  if (isPlayStyle(n)) {
    return n;
  }
  throw new ParsePlayStyleError("PlayStyleに変換できません");
};

export class ParsePlayStyleError extends BaseError {}
